<template>
    <footer
        id="ReaderFooter"
        ref="ReaderFooter"
        dusk="ReaderFooter"
        role="contentinfo"
        :inert="uiHidden"
        :class="[
            'ReaderFooter',
            'flex',
            'items-center',
            'group',
            'fixed',
            'bottom-0',
            'select-none',
            'text-theme-text',
            'pt-4',
            'hover:opacity-100',
            'z-10',
            'rounded-t-lg',
            { 'bg-theme-bg': !uiHidden },
        ]"
    >
        <Container>
            <transition name="slide-bottom-transition">
                <Row v-if="isOffline">
                    <LayoutCol :class="{ 'mb-2': !uiHidden }">
                        <ComponentNetworkStatus />
                    </LayoutCol>
                </Row>
            </transition>
            <Row>
                <LayoutCol class="px-4 md:px-0">
                    <transition name="fade-transition">
                        <ReadProgress v-show="!uiHidden" :class="[hideClass]" />
                    </transition>
                    <ComponentRangePaginator
                        v-if="showRangePaginator"
                        :class="['group-hover:opacity-100', paginatorOpacityClass]"
                    />
                </LayoutCol>
            </Row>
            <transition name="slide-bottom-transition">
                <Row
                    v-if="onlyMobileVisible && !uiHidden"
                    :class="['transition', 'duration-100', 'ease-in-out', 'pb-4', hideClass]"
                >
                    <LayoutCol class="px-4">
                        <PdfEpubActionsFooter class="text-theme-icon" />
                    </LayoutCol>
                </Row>
            </transition>
        </Container>
    </footer>
</template>

<script>
'use strict';

import { mapGetters, mapMutations, mapState } from 'vuex';
import ComponentRangePaginator from './Components/ComponentRangePaginator.vue';
import ReadProgress from './Components/ReadProgress.vue';
import PdfEpubActionsFooter from './Footer/PdfEpubActionsFooter.vue';
import ComponentNetworkStatus from './Components/ComponentNetworkStatus.vue';

export default {
    components: {
        ComponentRangePaginator,
        ReadProgress,
        PdfEpubActionsFooter,
        ComponentNetworkStatus,
    },
    computed: {
        ...mapState(['uiHidden', 'isOffline']),
        ...mapGetters(['showRangePaginator', 'onlyMobileVisible']),
        hideClass() {
            return this.uiHidden ? 'opacity-0 hidden' : 'opacity-100';
        },
        paginatorOpacityClass() {
            return this.uiHidden ? 'opacity-40 active:opacity-100 hover:opacity-100' : 'opacity-100';
        },
    },
    watch: {
        uiHidden() {
            this.$nextTick(() => {
                // Wait 200ms that is the duration of duration-200
                setTimeout(() => {
                    this.setFooterbarOffsetHeight(this.$refs.ReaderFooter.offsetHeight);
                }, 200);
            });
        },
    },
    mounted() {
        this.setFooterbarOffsetHeight(this.$refs.ReaderFooter.offsetHeight);
    },
    methods: {
        ...mapMutations(['setFooterbarOffsetHeight']),
    },
};
</script>
<style>
.ReaderFooter {
    left: calc(var(--sidebar-offset-left, 0px) + 16px);
    right: calc(var(--sidebar-offset-right, 0px) + 16px);
    transition:
        left 0.3s cubic-bezier(0.16, 1, 0.3, 1),
        right 0.3s cubic-bezier(0.16, 1, 0.3, 1),
        opacity 0.2s ease-out;
}

@media screen and (max-width: 570px) {
    .ReaderFooter {
        left: 0;
        right: 0;
    }
}
</style>

<style scoped>
/* Custom height transition animation for smooth effect */
.slide-bottom-transition-enter-active,
.slide-bottom-transition-leave-active {
    @apply transition-all duration-300 ease-in-out;
}

.slide-bottom-transition-enter,
.slide-bottom-transition-leave-to {
    @apply max-h-0 overflow-hidden;
}

.slide-bottom-transition-enter-to,
.slide-bottom-transition-leave {
    @apply max-h-[1000px];
}
</style>
